import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { DatePipe } from '@angular/common';
import { SearchTableState } from "../search-table-state";
import { BaseService } from "../base.service";
import { FraudReportEntries } from "./fraud-report-entries";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class FraudReportsService extends BaseService {

    private static searchUrl: string = '/api/fraud/search';
    private static exportExcelUrl: string = '/api/fraud/exportExcel';
    private static fraudSiteUrl: string = '/api/fraud';
    public searchTableState: SearchTableState = null;

    constructor(
        private http: HttpClient,
        private datePipe: DatePipe
    ) {
        super();
        this.searchTableState = new SearchTableState();
        this.searchTableState.propertyName = 'CreateDateUtc';
    }

    private searchTableStateCopy(): any {
        let copy: any = Object.assign({}, this.searchTableState);
        /* Disable refresh search */
        copy.lastRefreshed = new Date();
        if (copy.lastRefreshed) {
            copy.lastRefreshed = new Date(copy.lastRefreshed.getTime() + -1 * (new Date().getTimezoneOffset() * 60000));
        }
        this.updateFilterField(copy, 'mobileNumber', 'mobileNumberCondition');
        return copy;
    }

    public search(): Observable<Array<FraudReportEntries>> {
        let copy = this.searchTableStateCopy();
        return this.http.post<any>(FraudReportsService.searchUrl, copy)
            .map(data => {
                let fraudReportEntries: Array<FraudReportEntries> = this.dataToReportEntry(data);
                this.searchTableState.totalItems = parseInt(fraudReportEntries.length ? data[0].Total : 0);
                return fraudReportEntries;
            });
    }

    public dataToReportEntry(data: any): Array<FraudReportEntries> {
        let fraudReportEntries = new Array<FraudReportEntries>();
        if (data == null) {
            return fraudReportEntries;
        }
        for (let d of data) {
            let fraudReportEntry = new FraudReportEntries();
            fraudReportEntry.mobileNumber = d.MobileNumber;
            fraudReportEntry.dateCreatedUtc = d.DateCreatedUtc;
            fraudReportEntry.flaggedReason = d.FlaggedReason;
            fraudReportEntry.transactionStartDate = d.TransactionsStartDate;
            fraudReportEntry.transactionEndDate = d.TransactionsEndDate;
            fraudReportEntry.userStatus = d.UserStatus;
            fraudReportEntry.userActive = (d.StatusId == 2 || d.StatusId == 4) ? false: true;
            fraudReportEntries.push(fraudReportEntry);
        }
        return fraudReportEntries;
    }

    public exportExcel(): Observable<any> {
        let copy = this.searchTableStateCopy();
        return this.http.post<any>(FraudReportsService.exportExcelUrl, copy, {responseType: 'blob' as 'json'});
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/fraud-reports/fraud-reports.service.ts